<template >
  <p class="property">
    <span class="name">{{ name }}:</span>
    <slot></slot>
  </p>
</template>
<script>
export default {
  props: ["name"],
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/sass/main.scss";

.property {
  padding-bottom: 10px;
}

.property .name {
  color: $grey;
}
</style>
